
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sap-hana",
      function () {
        return require("private-next-pages/destinations/sap-hana.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sap-hana"])
      });
    }
  